import * as Yup from 'yup';
import Translator from '../../core/i18n';
import { Log } from 'ng2-logger';

const T = Translator.create();

const _logger = Log.create('change-password-validations');
export const RegExpCharacterLength = /^.{8,}$/;
export const RegExpSpecialCharacter = /[*@!-=.#%&()^~{}]+/;
export const RegExpUpperCase = /[A-Z]+/;
export function getValidation(props: any) {


    return Yup.object().shape({
        oldPassword: Yup.string()
            .required(T.t('r_enter_old_password')),
        newPassword: Yup.string()
            .required(T.t('r_field_required'))
            .matches(/^\S*$/, T.t('r_whitespace_is_not_allowed'))
            .test('newPasswordLength', T.t('r_atleast_eight_character').replace('{0}', props.minPassWordLength), val => val?.length >= props.minPassWordLength)
            .matches(RegExpUpperCase, T.t('r_uppercase_chracter_required'))
            .matches(RegExpSpecialCharacter, T.t('r_special_character_required')),
        confirmNewPassword: Yup.string()
            .required(T.t('r_field_required'))
            .oneOf([Yup.ref('newPassword'), ''], T.t('r_re_enter_password')),
    });
}